import styled from 'styled-components';
import Radio from './Radio';
import Checkbox from './Checkbox';
import GroupedInput from './GroupedInput';
import Slider from 'src/common/components/Sliders';
import { Props } from './types';
import { FlexCol } from './Common';
import Custom from './Custom';
import NormalInput from './NormalInput';
import NumberInput from './NumberInput';
import CurrencyInput from './CurrencyInput';
import CausesInput from './CausesInput';
import AutocompleteSelect from './SelectInput';

function QuestionTypeFactory({
  questionItem,
  selectedIndex = 0,
  totalLength = 0,
  questionIndex = 0,
  questionnaireValue,
  setQuestionnaireValue,
  selectedQuestionId,
  error,
  setError,
  questions,
}: Props) {
  return (
    <FlexCol>
      {(() => {
        switch (questionItem.type) {
          case 'SLIDER':
            return (
              <Slider
                metadata={questionItem.metadata}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                selectedQuestionId={selectedQuestionId}
                attributeKey={questionItem.attributeKey}
                error={error}
                setError={setError}
                questions={questions}
              />
            );
          // case 'GROUPED_CHECKBOX':
          //   return (
          //     <GroupedInput
          //       options={questionItem.options ?? []}
          //       selectedQuestionId={selectedQuestionId}
          //       questionnaireValue={questionnaireValue}
          //       setQuestionnaireValue={setQuestionnaireValue}
          //       setError={setError}
          //     />
          //   );
          case 'CHECKBOX':
            return (
              <Checkbox
                label={questionItem.label}
                options={questionItem.options ?? []}
                selectedQuestionId={selectedQuestionId}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                error={error}
                setError={setError}
              />
            );
          // case 'INPUT':
          //   return (
          //     <NormalInput
          //       label={questionItem.label}
          //       selectedQuestionId={selectedQuestionId}
          //       questionnaireValue={questionnaireValue}
          //       setQuestionnaireValue={setQuestionnaireValue}
          //       attributeKey={questionItem.attributeKey}
          //       error={error}
          //       setError={setError}
          //       source={questionItem.source}
          //     />
          //   );
          case 'NUMBER':
            return (
              <NumberInput
                metadata={questionItem.metadata}
                label={questionItem.label}
                selectedQuestionId={selectedQuestionId}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                type="number"
                attributeKey={questionItem.attributeKey}
                error={error}
                setError={setError}
                questions={questions}
              />
            );
          case 'CURRENCY':
            return (
              <CurrencyInput
                label={questionItem.label}
                selectedQuestionId={selectedQuestionId}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                type="number"
                attributeKey={questionItem.attributeKey}
                metadata={questionItem.metadata}
                error={error}
                setError={setError}
              />
            );
          case 'RADIO':
            return (
              <Radio
                label={questionItem.label}
                options={questionItem.options}
                attributeKey={questionItem.attributeKey}
                selectedQuestionId={selectedQuestionId}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                questions={questions}
                setError={setError}
              />
            );
          // case 'GROUPED_RADIO':
          //   return (
          //     <GroupedInput
          //       selectedQuestionId={selectedQuestionId}
          //       options={questionItem.options ?? []}
          //       radio
          //       questionnaireValue={questionnaireValue}
          //       setQuestionnaireValue={setQuestionnaireValue}
          //       setError={setError}
          //     />
          //   );
          case 'CAUSES_INPUT':
            return (
              <CausesInput
                label={questionItem.label}
                options={questionItem.options}
                attributeKey={questionItem.attributeKey}
                selectedQuestionId={selectedQuestionId}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                questions={questions}
                error={error}
                setError={setError}
              />
            );
          // case 'SELECT_INPUT':
          //   return (
          //     <AutocompleteSelect
          //       label={questionItem.label}
          //       options={questionItem.options}
          //       attributeKey={questionItem.attributeKey}
          //       selectedQuestionId={selectedQuestionId}
          //       questionnaireValue={questionnaireValue}
          //       setQuestionnaireValue={setQuestionnaireValue}
          //       questions={questions}
          //       error={error}
          //       setError={setError}
          //     />
          //   );
          case 'CUSTOM':
            return (
              <Custom
                selectedQuestionId={selectedQuestionId}
                // code={questionItem.code}
                questionnaireValue={questionnaireValue}
                setQuestionnaireValue={setQuestionnaireValue}
                error={error}
                setError={setError}
              />
            );
          default:
            return <></>;
        }
      })()}
    </FlexCol>
  );
}

export default QuestionTypeFactory;
